import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { buttonVariants } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { DeleteUserDialogProps } from '../types';

export function DeleteUserDialog({ user, isDeleting, onOpenChange, onConfirm }: DeleteUserDialogProps) {
  return (
    <AlertDialog open={!!user} onOpenChange={(open) => !open && onOpenChange(open)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить аккаунт {user?.email || `@${user?.username ?? ''}`}?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="flex flex-col gap-2 text-sm text-text-2">
              <p className="m-0">Пользователь будет разлогинен на всех устройствах и не сможет войти.</p>
              <p className="m-0">Прогресс и подписка сохранятся в базе — аккаунт можно восстановить.</p>
              <p className="m-0 text-text">Он не сможет зарегистрироваться заново с этим email — email останется занят.</p>
              {user?.isSubscribed && (
                <p className="m-0 rounded-xl bg-neg-soft p-3 font-semibold text-neg">
                  У пользователя активная подписка. Удаление аккаунта не отменяет подписку
                  в App Store / Google Play — её должен отменить сам пользователь.
                </p>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Отмена</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isDeleting}
            className={buttonVariants({ variant: 'destructive' })}
          >
            {isDeleting && <Loader2 className="animate-spin" />}
            Удалить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
